<template>
    <model-modal
        :model-class="modelClass"
        @opening="onOpening"
        @resetted="onReset"
        ref="modal"
        content-classes="flex flex-col h-full overflow-y-auto items-center"
        slotContainerClasses="w-full h-full relative"
    >
        <template v-slot:default="slotProps">
            <div class="flex flex-col h-full" v-if="model">
                <div class="p-8 border-b border-gray-300">
                    <h2 class="mb-8 text-xl font-thin text-gray-800">
                        {{ model.title }}
                        <span class="block text-sm">
                            {{ $t('calendar-event.full_date', {
                                date: model.getStartsAt().format('dddd, DD MMMM YYYY'),
                                start: model.getStartsAt().format('HH:mm'),
                                end: model.getEndsAt().format('HH:mm')
                            }) }}
                        </span>
                    </h2>
                    <div class="mb-4">
                        <p class="text-sm text-gray-600">
                            {{ $t('calendar-event.labels.user') }}
                        </p>
                        <p class="text-gray-900">
                            {{ model.user ? model.user.getName() : $t('calendar-event.no_user') }}
                        </p>
                    </div>
                    <div class="mb-4">
                        <p class="text-sm text-gray-600">
                            {{ $t('calendar-event.labels.address') }}
                        </p>
                        <p class="text-gray-900">
                            {{ model.address ? model.address.display : $t('calendar-event.no_address') }}
                        </p>
                    </div>
                    <!-- <div class="mb-4">
                        <p class="text-sm text-gray-600">Paramètres (t)</p>
                        <p class="text-gray-900">
                            <i class="mr-1 far" :class="model.accounted_for_weekly_hours ? 'text-green-600 fa-check-circle' : 'text-red-600 fa-times-circle'"></i>
                            <span>Comptabilité dans le suivi de temps (t)</span>
                        </p>
                        <p class="text-gray-900">
                            <i class="mr-1 far" :class="model.timetracking_allowed ? 'text-green-600 fa-check-circle' : 'text-red-600 fa-times-circle'"></i>
                            <span>Suivi de temps autorisé (t)</span>
                        </p>
                    </div> -->
                    <div class="mb-4">
                        <p class="text-sm text-gray-600">
                            {{ $t('calendar-event.labels.notes') }}
                        </p>
                        <p class="text-gray-900">
                            {{ model.notes ? model.notes : $t('calendar-event.no_notes') }}
                        </p>
                    </div>
                </div>
                <div class="p-8 border-b border-gray-300">
                    <h2 class="mb-4 text-lg">
                        {{ $t('calendar-event.labels.time_activities') }}
                    </h2>
                    <div
                        class="flex items-center px-8 space-x-4 bg-white border border-gray-300 rounded"
                        v-if="! activities.collection || activities.collection.isEmpty()"
                    >
                        <div class="h-[60px] w-[60px]">
                            <lottie json="https://shared-assets.trustup.io/lottie/planning-time-activity.json" container-class-name="lottie-planning-time-activity-animation-container"></lottie>
                        </div>
                        <div class="py-8 text-sm text-gray-800">
                            {{ $t('calendar-event.no_time_activities') }}
                        </div>
                    </div>
                    <div
                        class="relative flex flex-col space-y-2"
                        :class="{
                            'max-h-[350px] overflow-y-hidden': activities.more_displayable && ! activities.displayMore,
                            'pb-[50px]': activities.more_displayable
                        }"
                        v-else
                    >
                        <time-activity-item
                            v-for="activity in activities.collection.get()"
                            :key="activity.uuid"
                            :activity="activity"
                        ></time-activity-item>
                        <div class="absolute bottom-0 left-0 right-0 flex justify-center" v-if="activities.more_displayable">
                            <button @click.prevent="activities.displayMore = ! activities.displayMore" :class="{'mb-[20px]':  ! activities.displayMore}" class="relative z-10 flex items-center px-4 py-2 text-sm text-gray-600 bg-white border border-gray-400 rounded-full hover:shadow">
                                <i class="mr-1 far" :class="activities.displayMore ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                <span>
                                    {{ activities.displayMore ? $t('worksite-phase-task-modal.display_less_time_activities') : $t('worksite-phase-task-modal.display_more_time_activities') }}
                                </span>
                            </button>
                            <div class="absolute bottom-0 left-0 right-0 h-[100px] bg-white-to-transparent" v-if="! activities.displayMore"></div>
                        </div>
                    </div>
                </div>
                <div class="p-8" v-if="model.worksite">
                    <h2 class="mb-4 text-lg">
                        {{ $t('calendar-event.labels.worksite')}}
                    </h2>

                    <div class="mb-4">
                        <p class="text-sm text-gray-600">
                            {{ $t('calendar-event.labels.worksite_title') }}
                        </p>
                        <p class="text-gray-900">
                            {{ model.worksite.title }}
                        </p>
                    </div>

                    <div class="mb-4">
                        <p class="text-sm text-gray-600">
                            {{ $t('calendar-event.labels.worksite_address') }}
                        </p>
                        <p class="text-gray-900">
                            {{ model.worksite.address ? model.worksite.address.display : $t('calendar-event.no_address') }}
                        </p>
                    </div>

                    <template v-if="model.worksitePhase">
                        <div class="mb-4">
                            <p class="text-sm text-gray-600">
                                {{ $t('calendar-event.labels.worksite_phase') }}
                            </p>
                            <p class="text-gray-900">
                                {{ model.worksitePhase.title }}
                            </p>
                        </div>
                        <div class="mb-4" v-if="model.worksitePhase.trustup_io.tasks.tasks && model.worksitePhase.trustup_io.tasks.tasks.isNotEmpty()">
                            <p class="text-sm text-gray-600 mb-1">
                                {{ $t('calendar-event.labels.tasks') }}
                            </p>
                            <div class="flex flex-col space-y-2">
                                <trustup-io-task
                                    v-for="task in model.worksitePhase.trustup_io.tasks.tasks.get()"
                                    :key="task.uuid"
                                    :task="task"
                                ></trustup-io-task>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </model-modal>
</template>

<script>
    import ModelModal from '@spa/apps/trustup-pro-base-js/components/Model/Modal';
    import CalendarEvent from '@spa/apps/trustup-pro-planning-js/models/CalendarEvent';
    import TrustupIoTask from '@spa/apps/trustup-pro-base-js/components/TrustUpIO/Task/Item';
    import TimeActivityItem from '@spa/apps/trustup-pro-planning-js/components/TimeActivity/Item';
    import Lottie from '@spa/apps/trustup-pro-base-js/components/Lottie';

    export default {
        components: {
            ModelModal,
            TrustupIoTask,
            TimeActivityItem,
            Lottie
        },

        data() {
            return {
                modelClass: CalendarEvent,
                activities: {
                    loading: true,
                    collection: null,
                    displayMore: false
                },
            }
        },

        computed: {
            'activities.more_displayable'() {
                return this.activities.collection?.length() > 4;
            },
            model()
            {
                return this.$refs.modal?.model || null;
            },
        },

        methods: {
            onOpening({model})
            {
                this.activities.collection = model.time_activities;
            },
            
            onReset()
            {
                this.calendarEvent = null;
                this.activities = {
                    loading: true,
                    collection: [],
                    displayMore: false
                };
            }
        },
    }
</script>